import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import FileQueueLine from "./fileQueueLine/fileQueueLine";
import {formatFileSize, isOnlyMobileDevice} from "../../../../utils/utils";
import '../../commonDrive.css'
import {toast} from "react-toastify";
import functions from "../../../../utils/functionsFirebase";
import {useDispatch, useSelector} from "react-redux";
import drive from "../../../drive";
import users from "../../../users";
import './fileUploadMenu.css'
import UploadUtils from "../../uploadUtils/uploadUtils";
import {TORRESOWO_URL} from "../../../../utils/consts";

function FileUploadMenu({inMyDrive, onlyInfo}) {

    const dispatch = useDispatch();
    const intl = useIntl();

    let [dragOver, setDragOver] = useState(false);
    let lastTimeOver = null;
    const delay = ms => new Promise(res => setTimeout(res, ms));

    const currentFolderId = useSelector(drive.selectors.getCurrentFolderId);
    const draggingItem = useSelector(drive.selectors.isDraggingItem);
    const fileQueue = useSelector(drive.selectors.getUploadQueue);
    const isUploading = useSelector(drive.selectors.isUploading);
    const uploadingFile = useSelector(drive.selectors.getUploadingFile);
    const uploadProgress = useSelector(drive.selectors.getUploadProgress);
    const uploadSpeed = useSelector(drive.selectors.getUploadSpeed);
    const uploadTimeLeft = useSelector(drive.selectors.getUploadTimeLeft);

    console.log(uploadTimeLeft, uploadSpeed, uploadProgress);

    const uploadUtils = useRef(null);

    useEffect(() => {
        if (onlyInfo) {
            return;
        }

        async function continueFileUploading() {
            if (uploadingFile) {
                return;
            }
            if (fileQueue.length === 0) {
                return;
            }

            const auxFile = fileQueue[0]

            // Create a reference to the file in the database
            const uploadFile = functions.httpsCallable('createFileDetails');
            let result = null;
            const fileName = `${auxFile.name.replace(',', '')}.${auxFile.extension}`;
            try {
                result = await uploadFile({
                    name: fileName, size: auxFile.file.size,
                    type: auxFile.file.type, folderId: auxFile.folderId,
                    extension: auxFile.extension
                });
                auxFile.id = result.data.cryptedName;
                dispatch(drive.actions.setUploadingFile(auxFile));

                dispatch(drive.actions.uploadingNewFile())
            } catch (error) {
                toast.error(<FormattedMessage
                    id={"errors.no-size"}
                    values={{fileName: auxFile.file.name, size: formatFileSize(auxFile.file.size)}}
                />);

                dispatch(drive.actions.finishUploading())
                dispatch(drive.actions.shiftFileUploadQueue());
                return;
            }

            // Upload the real file to the storage server
            const formData = new FormData();
            formData.append('file', auxFile.file);
            formData.append('token', result.data.cap17oken);
            formData.append('name', fileName);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${TORRESOWO_URL}/uploadFile`, true);

            const lastLoadedItems = [];

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const progress = Math.round((event.loaded / event.total) * 100);
                    dispatch(drive.actions.setNewUploadProgress(progress));
                    const loadedItem = {
                        loaded: event.loaded,
                        total: event.total,
                        date: Date.now(),
                    };
                    lastLoadedItems.push(loadedItem);
                    if (lastLoadedItems.length > 3) {
                        lastLoadedItems.shift();
                    }

                    if (lastLoadedItems.length === 1) {
                        dispatch(drive.actions.setUploadSpeed(0));
                        dispatch(drive.actions.setUploadTimeLeft(99999999));
                    } else {
                        const totalLoaded = lastLoadedItems.at(-1).loaded - lastLoadedItems[0].loaded;
                        const totalTime = (lastLoadedItems.at(-1).date - lastLoadedItems[0].date) / 1000;
                        const speed = totalLoaded / totalTime;
                        dispatch(drive.actions.setUploadSpeed(speed));

                        const timeLeft = (event.total - event.loaded) / speed;
                        dispatch(drive.actions.setUploadTimeLeft(timeLeft));
                    }
                }

            };

            xhr.onerror = (e) => {
                toast.error('Error al subir el archivo');
                console.error('Error al subir el archivo', e);
                dispatch(drive.actions.finishUploading());
                dispatch(drive.actions.shiftFileUploadQueue());
                deleteFileReference(auxFile);
            };

            xhr.onload = async () => {
                console.log(xhr);
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        const fileUrl = response.file.url;
                        const uploadFile = functions.httpsCallable('saveFileDetails');
                        uploadFile({id: result.data.cryptedName, fileUrl})
                            .then(result => {
                                if (result.data.folderId + '' === currentFolderId + '') {
                                    dispatch(drive.actions.uploadedNewFile(result.data));
                                }
                                dispatch(users.actions.addedFilesUpdateSize([result.data]));
                            })
                            .catch(error => {
                                toast.error(error);
                            })
                            .finally(() => {
                                dispatch(drive.actions.finishUploading());
                                dispatch(drive.actions.shiftFileUploadQueue());
                            });
                    } catch (error) {
                        toast.error('Error procesando la respuesta del servidor');
                    }
                } else {
                    toast.error('Error en la subida del archivo');
                }
            };

            xhr.send(formData);
        }

        if (fileQueue.length > 0) {
            continueFileUploading();
        }
    }, [fileQueue, uploadingFile])

    useEffect(() => {
        const handlePageUnload = (event) => {
            if (uploadingFile !== null) {
                onDeleteFile(uploadingFile.file.name);
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handlePageUnload);
        window.addEventListener('unload', handlePageUnload);

        return () => {
            window.removeEventListener('beforeunload', handlePageUnload);
            window.removeEventListener('unload', handlePageUnload);
        };
    }, [uploadingFile]);

    const onDeleteFile = async (fileName) => {
        if (fileName === uploadingFile.file.name) {
            await deleteFileReference(uploadingFile);
        }
        dispatch(drive.actions.removeFileUploadQueue(fileName))
    }

    async function deleteFileReference(file) {
        const deleteFiles = functions.httpsCallable("deleteFileDetails");
        await deleteFiles({id: file.id});
    }

    async function dropHandler(ev) {
        dragOver = false;
        await uploadUtils.current.dropHandler(ev, currentFolderId);
        setDragOver(false);
    }

    function dragOverHandler(ev) {
        if (draggingItem) {
            return;
        }
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        if (!dragOver) {
            const listaFicheros = document.getElementById('lista-ficheros');
            listaFicheros.classList.remove('drive__dropZoneInactive');
            setDragOver(true);
        }
        lastTimeOver = new Date().getTime();
    }

    async function dragLeaveHandler(ev) {
        if (draggingItem) {
            return;
        }
        ev.preventDefault();
        await delay(200);
        if ((lastTimeOver - new Date().getTime()) > -150) {
            return;
        }
        const listaFicheros = document.getElementById('lista-ficheros')
        listaFicheros.classList.add('drive__dropZoneInactive');
        setDragOver(false);
    }

    if (!inMyDrive && isUploading) {

        return (
            <FileQueueLine file={uploadingFile?.file}
                           name={uploadingFile?.name}
                           downloadSpeed={uploadSpeed}
                           extension={uploadingFile?.extension}
                           progress={uploadProgress}/>
        )
    }

    if (!inMyDrive) {
        return null;
    }

    return (
        <div className="col-12 d-flex align-items-end flex-column " style={{height: '75%'}}>
            <div className="d-grid col-12 mb-3">
                <button className="btn btn-outline-secondary btn-block col-12"
                        onClick={() => uploadUtils.current.handleAddFilesButton()}>
                    <FormattedMessage id="drive.contextual.add-file"/></button>
            </div>
            <div className="d-grid col-12 fileUploadMenu__filesCard"
                 onDragOver={dragOverHandler} onDragLeave={dragLeaveHandler} onDrop={dropHandler}>
                <div id="lista-ficheros"
                     style={{position: 'absolute', zIndex: '2', width: '100%', height: '100%', pointerEvents: 'none'}}
                     className="d-flex justify-content-center align-items-center drive__dropZoneActive drive__dropZoneInactive">
                    <div hidden={!dragOver}>
                        <i style={{fontSize: "xxx-large"}} className="fa-solid fa-upload text-muted"></i>
                    </div>
                </div>
                {fileQueue.length > 0 &&
                    <ul className="list-group" style={{zIndex: 1, overflowY: "scroll", padding: 0}}>
                        {
                            fileQueue.map(file =>
                                <FileQueueLine
                                    onDelete={file.file.name === uploadingFile?.file.name ? null : onDeleteFile}
                                    key={file.name} file={file.file}
                                    name={file.name}
                                    downloadSpeed={file.file.name === uploadingFile?.file.name ? uploadSpeed : null}
                                    extension={file.extension}
                                    progress={file.file.name === uploadingFile?.file.name ? uploadProgress : null}/>
                            )
                        }
                    </ul>
                }

                {fileQueue.length === 0 &&
                    <div className="p-3">
                        <div className="alert alert-info d-flex align-items-center" style={{height: 'auto'}}
                             role="alert">
                            {isOnlyMobileDevice() ?
                                <FormattedMessage id="drive.contextual.files.empty-phone"/>
                                :
                                <FormattedMessage id="drive.contextual.files.empty"/>
                            }
                        </div>
                    </div>
                }
            </div>
            <UploadUtils ref={uploadUtils}/>
        </div>
    )

}

export default FileUploadMenu;
